import { compact, map } from "lodash/fp";

import { get, post } from "@readai/common/api";
import type { RecommendationAction } from "@readai/common/types/recommendationTypes";

import * as RecommendationsParser from "./parsers/recommendations";

export const getRecommendationsForUser = async () => {
  const response = await get("/users/me/recommendations", { withCreds: true });

  return RecommendationsParser.parseRecommendations(
    response?.data?.recommendations?.meetings ?? [],
  );
};

export const postRecommendationAction = async ({
  action,
  isAccepted,
}: {
  action: RecommendationAction;
  isAccepted: boolean;
}): Promise<void> =>
  post(
    "/recommendations/execute",
    { isAccepted, operationToken: action.operationToken },
    { withCreds: true },
  );

interface PostRecommendationsActionBody {
  isAccepted: boolean;
  recommendations: {
    action: RecommendationAction;
  }[];
}

export const bulkPostRecommendationsAction = async ({
  recommendations,
  isAccepted,
}: PostRecommendationsActionBody): Promise<
  PostRecommendationsActionBody["recommendations"]
> => {
  const results = await Promise.allSettled(
    map(async (rec) => {
      await postRecommendationAction({
        action: rec.action,
        isAccepted,
      });
    }, recommendations),
  );

  return compact(
    results.map((result, i) =>
      result.status === "rejected" ? recommendations[i] : null,
    ),
  );
};
